import { useSavedSearches } from '~/context/srp/SavedSearchesContext';

export default function useLoadSaveSearchNudge() {
  return useSavedSearches().length === 0;
}
